import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClassType } from '../../../types/Class';

const initialState:ClassType = {
  description: '',
  idAcademicYear: '',
  idCourse: '',
  level: 0,
  semester: 0,
  idFaculty: '',
  idDepartament: '',
  useOwnRulesForAcademicPeriod: false
}

const classSlice = createSlice({
  name: "classForm",
  initialState,
  reducers: {
    setClassData:(state, action:PayloadAction<ClassType>)=>({...state, ...action.payload}), 
    resetClassData :()=>({...initialState})
  }
});

export const {setClassData, resetClassData} = classSlice.actions

export default classSlice.reducer